module.exports = __webpack_public_path__ + "media/src/assets/images/ai-pic-cca43d208d484da911ebaaefa0109bb0.png";